export function userReducer(state = {}, action) {
    switch (action.type) {
        case '@@acuant/POPULATE_USER_PROFILE':
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}